import React from 'react'

function Verify() {
  window.parent.postMessage('CLOSE_IFRAME', window.location.origin);

  return (
    <div></div>
  )
}

export default Verify